import { Component, ContentChild, HostBinding, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ihm-drawer-button',
  templateUrl: './ihm-drawer-button.component.html',
  styleUrls: ['./ihm-drawer-button.component.scss']
})
export class IhmDrawerButtonComponent {
  @Input() readonly bottomGap: number = 0;
  @Input() readonly buttonLabel: string = 'Open Drawer';
  @Input() readonly buttonCloseLabel: string = 'Close Drawer';
  @Input() readonly buttonTextColor: string = 'blue';
  @Input() readonly closeXColor: string = 'red';
  @Input() readonly mode: string = 'over';
  @Input() readonly position: string = 'end';
  @Input() readonly showCloseX: boolean = true;
  @Input() readonly showIcon: boolean = true;
  @Input() readonly topGap: number = 65;
  @Input() readonly width: number = 400;
  opened = false;

  @HostBinding('attr.style')
  public get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(`--width: ${this.width}px`);
  }

  @ContentChild(TemplateRef, { read: TemplateRef })
  microUiTemplate: TemplateRef<any>;

  @ViewChild('sidenav')
  drawer: MatSidenav;

  get iconOpenClosed(): string {
    return this.opened ? 'close' : 'open_in_new';
  }

  constructor(private sanitizer: DomSanitizer) {}

  openMicroUI() {
    this.opened = !this.opened;
    this.drawer.toggle();
  }
}
